import React from "react";
import Select from "react-select";
import "chart.js/auto";
import "../../styles/common/dashboardCourseSection.scss";

import ChartCard from "./charts/ChartCard";
import DoughnutChart from "./charts/DoughnutChart";
import PolarAreaChart from "./charts/PolarAreaChart";
import RadarChart from "./charts/RadarChart";
import BarChart from "./charts/BarChart";
import LineChart from "./charts/LineChart";
import PieChart from "./charts/PieChart";

import CourseDashboardView from "../institution/CourseDashboardView";

const DashboardCourseSection = ({
  courseOptions,
  selectedCourseOption,
  onChangeCourse,
  courses,
  courseData,
  stats,
  overall,
  batches,
  showSelectRow = true,
}) => {
  const toMinutes = (seconds) => Math.round((seconds || 0) / 60);

  const courseKey =
    selectedCourseOption?.value ||
    courseData?.key ||
    courseData?.course_key ||
    courseData?.courseKey ||
    "";

  return (
    <CourseDashboardView 
      courseKey={courseKey}
      stats={stats || courseData?.stats} 
      overall={overall || courseData?.overall} 
      batches={batches || courseData?.batches}
      subjectWiseStats={courseData?.subject_wise_stats}
      toMinutes={toMinutes}
    />
  );
};

export default DashboardCourseSection;
